import React from 'react';
import { Navigate } from 'react-router-dom';

import { ReactComponent as CampaignManagement } from '../../../shared/assets/icons/menu-icons/campaign1x.svg';
import { RouteProps } from '../../../shared/models/route-props.model';
import BasicInfoValidationHelper from '../../components/campaign-basic-info/components/basic-info-validation-helper/basic-info-validation-helper';
import CampaignCreateLayout from '../../components/campaign-create-layout/campaign-create-layout';
import Campaigns from '../../components/campaign-landing-page/campaigns';
import CampaignsManagementPageLayout from '../../components/campaign-management-page-layout/campaigns-management-page-layout';
import VehiclePopulationFormContainer from '../../components/campaign-vehicle-population/vehicle-population-form-container';
import { VehicleReports } from '../../components/vehicle-reports/vehicle-reports';

export const getCampaignsRoutes = (): RouteProps[] => [
  {
    path: 'campaign-management',
    title: 'Campaigns',
    element: <CampaignsManagementPageLayout />,
    menuIcon: <CampaignManagement className="svg-icon" />,
    children: [
      {
        path: 'campaigns',
        title: 'Campaigns',
        element: <Campaigns />,
      },
      {
        path: 'create',
        title: 'Create New Campaign',
        element: <CampaignCreateLayout />,
        notVisibleInMenu: true,
        children: [
          {
            path: 'basic-information',
            title: 'Basic Information',
            element: <BasicInfoValidationHelper />,
          },
          {
            path: 'vehicle-population',
            title: 'Vehicle Population',
            element: <VehiclePopulationFormContainer />,
          },
          {
            path: 'reports',
            title: 'Reports',
            element: <VehicleReports />,
          },
        ],
      },
      {
        path: 'edit/:id',
        title: 'Create New Campaign',
        element: <CampaignCreateLayout />,
        notVisibleInMenu: true,
        children: [
          {
            path: '',
            title: 'Basic Information',
            element: <Navigate to={'/campaign-management/campaigns'} />,
          },
          {
            path: 'basic-information',
            title: 'Basic Information',
            element: <BasicInfoValidationHelper />,
          },
          {
            path: 'vehicle-population',
            title: 'Vehicle Population',
            element: <VehiclePopulationFormContainer />,
          },
          {
            path: 'reports',
            title: 'Reports',
            element: <VehicleReports />,
          },
        ],
      },
    ],
  },
];
